export default {
  widescreen: false
};
